module.exports = __webpack_public_path__ + "img/asset_MNDE.1dff3804.svg";